module.exports = __webpack_public_path__ + "static/media/first-ever-website.b356ab9c.md";